export default [
    {
        path: '/mechanics',
        name: 'Company / Mechanics',
        component: () => import('@/views/pages/mechanics'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'commissions',
                name: 'Company / Commissions Mechanic',
                component: () => import('@/views/pages/mechanics'),
                meta:
                {
                    page: 'commissions',
                },
            },
            {
                path: ':code',
                name: 'Company / View Mechanic',
                component: () => import('@/views/pages/mechanics'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];